import { useRef, useEffect } from 'react';

export function useIsMounted() {
  var isMounted = useRef(false);

  useEffect(function () {
    isMounted.current = true;

    return function () {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
}
//# sourceMappingURL=useIsMounted.js.map